export default __webpack_public_path__ + "8ff7ce92ad753b591ed4c1d03e84c026.svg";